import { useCallback } from 'react';

/**
 * Custom hook untuk membuka halaman baru.
 * @param {string} path - Path atau URL yang akan dibuka.
 * @returns {function} Fungsi untuk membuka halaman baru.
 */
const OpenNewPage = (path) => {
  const openNewPage = useCallback(() => {
    window.open(path, '_blank');
  }, [path]);

  return openNewPage;
};

export default OpenNewPage;